import React from "react";

export default function EmployeeSalaryAssignmentToolbar({
  search,
  setSearch,
  departmentFilter,
  setDepartmentFilter,
  designationFilter,
  setDesignationFilter,
  statusFilter,
  setStatusFilter,
  departments,
  designations,
  onAdd,
}) {
  return (
    <div className="finance-toolbar">

      <input
        type="text"
        className="finance-search"
        placeholder="Search employee..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      <select
        className="finance-select"
        value={departmentFilter}
        onChange={(e) => setDepartmentFilter(e.target.value)}
      >
        <option value="All">All Departments</option>

        {departments.map((dept) => (
          <option key={dept} value={dept}>
            {dept}
          </option>
        ))}
      </select>

      <select
        className="finance-select"
        value={designationFilter}
        onChange={(e) => setDesignationFilter(e.target.value)}
      >
        <option value="All">All Designations</option>

        {designations.map((designation) => (
          <option key={designation} value={designation}>
            {designation}
          </option>
        ))}
      </select>

      <select
        className="finance-select"
        value={statusFilter}
        onChange={(e) => setStatusFilter(e.target.value)}
      >
        <option value="All">All Status</option>
        <option value="Active">Active</option>
        <option value="Inactive">Inactive</option>
      </select>

      <button
        className="finance-primary-btn"
        onClick={onAdd}
      >
        + Assign Salary
      </button>

    </div>
  );
}